import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom'

// components
import SessionProvider from './components/sessionContext'
//scenes
import App from './scenes/App'
import Login from './scenes/Login'
import Logout from './scenes/Logout'

// session context
import { useSessionData } from './components/sessionContext'

//styles
import './index.css'
import 'semantic-ui-css/semantic.min.css'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const session = useSessionData()

  return (
  <Route {...rest} render={props => (
    session.isAuthenticated()
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)}

const Index = () => {

  return (
    <Router>
      <SessionProvider>
        <Switch className='router'>
          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <PrivateRoute path='/' component={App} />
        </Switch>
      </SessionProvider>
    </Router>
  )
}

ReactDOM.render(
  // <React.StrictMode>
    <Index />,
  // </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
